import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Urgence() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div
          ref={ref}
          className={`bg-slate-primary rounded-xl p-8 md:p-12 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="w-12 h-12 bg-urgent/20 rounded-full flex items-center justify-center mx-auto mb-5">
            <i className="ri-flashlight-fill text-urgent text-2xl" />
          </div>
          <h2 className="font-manrope font-bold text-white text-xl md:text-2xl lg:text-3xl mb-3">
            Votre projet est urgent ?
          </h2>
          <p className="text-white/60 text-sm md:text-base mb-8 max-w-md mx-auto">
            Ne perdez pas de temps. Parlez directement à un couvreur dès maintenant pour une réponse immédiate.
          </p>
          <a
            href="tel:+14184769950"
            aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
            title="Cliquez pour appeler"
            className="inline-flex items-center gap-3 bg-urgent hover:bg-urgent-dark text-white font-bold py-4 px-8 rounded-md text-base transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl" />
            Appelez directement le 418-476-9950
          </a>
        </div>
      </div>
    </section>
  );
}